import { HomeIcon, MoviesIcon, Plus, SearchIcon, SeriesIcon, SettingsIcon } from '@assets/index'

export const setMenuIcon = (icon: string) => {
  switch (icon) {
    case 'home':
      return <HomeIcon />
    case 'movies':
      return <MoviesIcon />
    case 'series':
      return <SeriesIcon />
    case 'search':
      return <SearchIcon />
    case 'default':
      return <Plus />
    case 'others':
      return <SettingsIcon />
    default:
      return <Plus />
  }
}
